export default class TableEntity {

  constructor(data) {
    this.id              = data.id;
    this.key             = data.tableKey;
    this.internalLabel   = data.internalLabel;
    this.createdAt       = data.createdAt;
    this.updatedConfigId = data?.updatedConfigId || null;
    this.columns         = data.tableColumns || [];
    this.configs         = data.tableConfigs || [];

  }
}
